import URLUTMGetter from "./URLUTMGetter";

export default class InteractionCookieSetter
{
    constructor(captureException = null) {
        this.captureException = captureException;
        this.initialize();
    }

    initialize() {
        try {
            const cookieExpires = 604800; // 7 days in seconds
            const urlUtmGetter = new URLUTMGetter(false, cookieExpires);
            const utms = urlUtmGetter.get();

            if (utms.source || utms.medium || utms.campaign || utms.content || utms.term) {
                const cookieName = 'interaction';

                const utm_source = utms.source || '';
                const utm_medium = utms.medium || '';
                const utm_campaign = utms.campaign || '';
                const utm_content = utms.content || '';
                const utm_term = utms.term || '';
                const cookieExpires = utms.cookieExpires;

                let cookieValue = JSON.stringify({
                    utm_source,
                    utm_medium,
                    utm_campaign,
                    utm_content,
                    utm_term
                });

                cookieValue = btoa(cookieValue.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
                const cookiePath = '/';
                document.cookie = `${cookieName}=${cookieValue}; path=${cookiePath}; max-age=${cookieExpires};`
            }
        } catch (e) {
            this.captureException?.(e);
        }
    }
}
